var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"top-bar",style:({background: _vm.linearGradientStyle})},[_c('h2',{staticClass:"headline"},[_vm._v(" "+_vm._s(_vm.title)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }